import axios from 'axios'
import { i18n } from '@/plugins'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { TOKEN_KEY } from '@/utils/constants'
import { auth } from '@/services/auth'
import { toast } from '@/utils'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT_URL,
  // axios 0.x のデフォルトは配列を `key[]=val` 形式にシリアライズするが、
  // FastAPI の `list[int] = Query(None)` は `key=val&key=val` 形式を期待するため、
  // ブラケットなしの繰り返しキー形式に変換するカスタムシリアライザを設定する。
  paramsSerializer: (params) => {
    const parts: string[] = []
    for (const [key, value] of Object.entries(params)) {
      if (value === undefined || value === null) continue
      if (Array.isArray(value)) {
        value.forEach((v) =>
          parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(v)}`)
        )
      } else {
        parts.push(
          `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`
        )
      }
    }
    return parts.join('&')
  }
})

api.interceptors.request.use(
  async (config) => {
    const token = await auth.getTokenSilently()
    if (token) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      config.headers.Authorization = `Bearer ${token}`
      localStorage.setItem(TOKEN_KEY, token)
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const skipToast = error.config && error.config._noToast
    if (skipToast) return Promise.reject(error)

    // toast error message
    if (
      error.response &&
      error.response.data &&
      error.response.data.reason_code
    ) {
      const { reason_code, detail, params } = error.response.data
      console.error(`Response error [${reason_code}]: ${detail}`)
      toast.error(i18n.t(`err_msg.${reason_code}`, { ...params }))
      // 呼び出し側のcatch(utils/errors/showError)が同じエラーを再度トーストしないよう、
      // ここで通知済みであることを記録する。
      error.isToastShown = true
    }
    return Promise.reject(error)
  }
)

export default api
